import use from './use';

const api = {
    use
};
window.FEGOWebapi = api;

export {
    use
};
